/*
SVG Sprite
*/
const files = require.context(__dirname, false, /\.svg$/);
files.keys().forEach(files);



// WEBPACK FOOTER //
// ./project/client/src/site__pol/sprites/index.js